import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { Collapse, Row, Col, Button } from 'antd';
import { getRole } from '../../reducers/userReducer';
import * as actions from '../../actions/actionCreators/accountGOSTransactionsListActionCreators';
import { TextField, DateRangeField, ClassificatorField } from '../../atoms';
import { FormActions } from '../../components';
import { downloadTradingAccountFileByGetURL } from '../../utils/files';
import { links } from '../../utils/gotoLink';
import {
  taTransactionsFilterFields,
  FORM_ACCOUNT_GOS_TRANSACTIONS_FILTER,
} from '../../constants/formAccountGOSTransactionsFilter';
import { getTransactionDateRanges } from '../../utils/dates';
import {
  formValueSelector,
  updateFormState,
} from '../../reducers/reactFinalFormReducer';
import FormStateToRedux from '../FormStateToRedux';
import RffFields from '../../atoms/rff/RffFields';

const { Panel } = Collapse;

export class AccountGOSTransactionsFilter extends Component {
  transactionDateFrom = '';
  transactionDateTo = '';
  transactionStatus = undefined;
  transactionType = undefined;
  type = undefined;

  static propTypes = {
    t: PropTypes.func.isRequired,
    userRole: PropTypes.string.isRequired,
    initialValues: PropTypes.object,
    searchAccountGOSTransactions: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { initialValues, updateFormState } = this.props;
    if (initialValues) {
      updateFormState(FORM_ACCOUNT_GOS_TRANSACTIONS_FILTER, {
        values: { ...initialValues },
      });
    }
  }

  handleExportTransactions = () => {
    const params = {
      registerCode:
        this.props.initialValues?.[taTransactionsFilterFields.REGISTER_CODE],
      transactionDateFrom: this.transactionDateFrom,
      transactionDateTo: this.transactionDateTo,
      transactionStatus: this.transactionStatus,
      transactionType: this.transactionType,
      type: this.type,
    };

    downloadTradingAccountFileByGetURL(
      links.tradingAccountCsv,
      params,
      'gos-account-transactions.csv'
    );
  };

  updateFilterFields = (values) => {
    if (values) {
      this.transactionDateFrom = values[taTransactionsFilterFields.DATE_FROM];
      this.transactionDateTo = values[taTransactionsFilterFields.DATE_TO];
      this.transactionStatus =
        values[taTransactionsFilterFields.TRANSACTION_STATUS];
      this.transactionType =
        values[taTransactionsFilterFields.TRANSACTION_TYPE];
      this.type = values[taTransactionsFilterFields.TYPE];
    }
  };

  onSubmit = (values) => {
    this.updateFilterFields(values);
    this.props.searchAccountGOSTransactions(values);
  };

  onClear = (form) => {
    const registerCode =
      this.props.initialValues?.[taTransactionsFilterFields.REGISTER_CODE];
    form.restart({
      [taTransactionsFilterFields.REGISTER_CODE]: registerCode,
    });
    this.props.updateFormState(FORM_ACCOUNT_GOS_TRANSACTIONS_FILTER, {
      values: {},
    });
  };

  render() {
    const { t, initialValues } = this.props;

    return (
      <React.Fragment>
        <Collapse>
          <Panel key="filters" header={t('transactions.filter.panelTitle')}>
            <Form
              initialValues={initialValues}
              onSubmit={this.onSubmit}
              render={({ handleSubmit, form }) => (
                <form onSubmit={handleSubmit}>
                  <FormStateToRedux
                    form={FORM_ACCOUNT_GOS_TRANSACTIONS_FILTER}
                  />

                  <Row gutter={24}>
                    <Col span={5}>
                      <Field
                        label={t('transactions.filter.transactionType')}
                        name={taTransactionsFilterFields.TRANSACTION_TYPE}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.gosTransactionType
                        }
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={5}>
                      <Field
                        label={t('transactions.filter.type')}
                        name={taTransactionsFilterFields.TYPE}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types
                            .tradingAccountTransactionRowType
                        }
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={5}>
                      <Field
                        label={t('transactions.filter.transactionStatus')}
                        name={taTransactionsFilterFields.TRANSACTION_STATUS}
                        component={ClassificatorField}
                        classificatorType={
                          ClassificatorField.types.transactionForGosStatus
                        }
                        hasFeedback={false}
                      />
                    </Col>
                    <Col span={9}>
                      <RffFields
                        label={t('transactions.filter.dateRange.title')}
                        names={[
                          taTransactionsFilterFields.DATE_FROM,
                          taTransactionsFilterFields.DATE_TO,
                        ]}
                        placeholder={[
                          t(
                            'transactions.filter.dateRange.dateFromPlaceholder'
                          ),
                          t('transactions.filter.dateRange.dateToPlaceholder'),
                        ]}
                        component={DateRangeField}
                        allowClear={false}
                        hasFeedback={false}
                        ranges={getTransactionDateRanges(t)}
                      />
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col span={12}>
                      <Field
                        name={taTransactionsFilterFields.REGISTER_CODE}
                        component={TextField}
                        hasFeedback={false}
                        type="hidden"
                      />
                    </Col>
                  </Row>
                  <FormActions>
                    <Button onClick={() => this.onClear(form)}>
                      {t('transactions.filter.clearBtn')}
                    </Button>
                    <Button type="primary" htmlType="submit">
                      {t('transactions.filter.submitBtn')}
                    </Button>
                  </FormActions>
                </form>
              )}
            />
          </Panel>
        </Collapse>
        <FormActions>
          <Button onClick={this.handleExportTransactions}>
            {t('exportCsvBtn')}
          </Button>
        </FormActions>
      </React.Fragment>
    );
  }
}

const selector = formValueSelector(FORM_ACCOUNT_GOS_TRANSACTIONS_FILTER);

const mapStateToProps = (state) => ({
  filterValues: selector(state),
  userRole: getRole(state),
});

const mapDispatchToProps = {
  searchAccountGOSTransactions: actions.searchAccountGOSTransactions,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountGOSTransactionsFilter);
